module.exports = __webpack_public_path__ + "img/y_2016.c02367f8.png";